
import React from 'react';

const DataController = () => {
  return (
    <div>
      <h3 className="text-xl font-semibold mb-3">III. Name and address of the data controller</h3>
      <p className="text-gray-600">
        AI Brainvisuals AG<br />
        St. Luzi Str. 43<br />
        9492 Eschen, Fürstentum Liechtenstein<br />
        Email: info@ai-brainvisuals.com
      </p>
    </div>
  );
};

export default DataController;
